import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import Accordion from '.';
import Html from '../Layout/Html';

const AccordionList = ({ heading, items }) => {
  return (
    <Box>
      <Html dangerouslySetInnerHTML={{ __html: heading }} />
      {items.map(item => (
        <Box my={3} key={item.id}>
          <Accordion {...item} />
        </Box>
      ))}
    </Box>
  );
};

AccordionList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
};

export default AccordionList;
